import { ServerApi } from 'modules/api/server-api';

import { CommonEntity } from '@/models/BaseTypes';

export const fetchWorkFeatures = (api: ServerApi) => async () => {
  const response = await api.get('/dictionary/work-features');
  return response.data['work-features'] as CommonEntity[];
};
